import classNames from 'classnames';
import { DetailedHTMLProps, HTMLAttributes } from 'react';

import { Event, ProjectType, PublicProject } from '../../Shared/types';
import { DonationBox, Icon, Medal, Megaphone } from '../../Shared/UI/Icon';

export const ProjectLabel = ({
  project,
  event,
  background = true,
  className,
  ...props
}: {
  project: PublicProject | null;
  event: Event | null;
  background?: boolean;
} & DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>) => {
  return (
    <span className={classNames('inline-flex max-w-full', className)} {...props}>
      <span className={classNames(
        background && 'bg-slate-800/5 text-slate-800 px-2 py-1',
        !background && 'text-slate-500',
        'block text-xs sm:text-sm leading-tight rounded-full text-ellipsis overflow-hidden whitespace-nowrap max-w-full'
      )}>
        <Icon className="mr-1">
          {event ? <Medal /> : (
            project?.type === ProjectType.DonationBox
              ? <DonationBox />
              : <Megaphone />
          )}
        </Icon>
        {project && !project.default ? project.title : (event?.title || project?.title)}
      </span>
    </span>
  );
};
